import { render, staticRenderFns } from "./exhibition-cert-no.vue?vue&type=template&id=3a5ed859&scoped=true&"
import script from "./exhibition-cert-no.vue?vue&type=script&lang=js&"
export * from "./exhibition-cert-no.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-cert-no.vue?vue&type=style&index=0&id=3a5ed859&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ed859",
  null
  
)

export default component.exports